
export const goalsData = [
  {
    title: "Gubitak viška kilograma i smanjenje potkožnog masnog tkiva",
    description: "Personalizirani program treninga i prehrane za optimalan gubitak masnoće, bez obzira na vaše trenutno iskustvo, kilažu, te brzinu metabolizma.",
    icon: (
      <svg className="w-12 h-12 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: "Izgradnja mišićne mase",
    description: "Znanstveno dokazan pristup izgradnji mišićne mase kroz optimizaciju treninga i prehrambenih navika za dugoročne i efikasne rezultate.",
    icon: (
      <svg className="w-12 h-12 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M6.5 6.5h11M6.5 17.5h11M5 10.5v3M19 10.5v3M9.5 5v14M14.5 5v14" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: "Tjelesna rekompozicija",
    description: "Transformacija vašeg tijela kroz istovremeno gubljenje viška kilograma i smanjenje potkožnog masnog tkiva, te izgradnju mišićne mase za sveukupno poboljšanje izgleda i vašeg zadovoljstva.",
    icon: (
      <svg className="w-12 h-12 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M13 10V3L4 14H11V21L20 10H13Z" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
];